function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="11" height="11" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.5 0A5.506 5.506 0 0 0 0 5.5C0 8.533 2.467 11 5.5 11S11 8.533 11 5.5 8.533 0 5.5 0zm3.158 4.571L5.203 8.026a.773.773 0 0 1-.55.228.773.773 0 0 1-.55-.228l-1.761-1.76a.773.773 0 0 1-.228-.55c0-.209.08-.404.228-.55a.772.772 0 0 1 .55-.229c.208 0 .403.081.55.228l1.21 1.211 2.906-2.905a.773.773 0 0 1 .55-.228.779.779 0 0 1 .55 1.328z" fill="#278C7E" /></svg>;
});